import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL || ""}/api`;

export const useDiscordStatus = () => {
  const [data, setData] = useState(null);
  useEffect(() => {
    let alive = true;
    axios
      .get(`${API}/discord-status`)
      .then((r) => alive && setData(r.data))
      .catch(() => alive && setData({ ok: false }));
    return () => { alive = false; };
  }, []);
  return data;
};
